module.exports = __webpack_public_path__ + "static/siam-tulip-0-082aacd1e1600896d8ac800b63c393e3.png";